import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@mui/material/Typography";
import IconPerson from "@material-ui/icons/PersonOutline";
import IconPlus from "@material-ui/icons/Add";
import IconMinus from "@material-ui/icons/Remove";
import IconChild from "@material-ui/icons/Face";
import IconBaby from "@material-ui/icons/EmojiEmotions";
import IconLuggage from "@material-ui/icons/WorkOutline";
import IconSuitcase from "@material-ui/icons/CardTravel";
import { KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  popoverCard: {
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
    padding: 24,
    minWidth: 320,
    maxWidth: 360,
  },
  sectionHeader: {
    fontWeight: 700,
    fontSize: '1.1rem',
    marginBottom: 8,
    marginTop: 8,
    color: '#222',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
    marginTop: 4,
  },
  labelGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  label: {
    fontWeight: 500,
    fontSize: '1rem',
    color: '#222',
  },
  ageRange: {
    fontSize: '0.95rem',
    color: '#8b98a9',
    marginLeft: 6,
    fontWeight: 400,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  controlBtn: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    background: '#f3f6fa',
    color: '#4a5568',
    border: 'none',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 20,
    transition: 'background 0.2s',
    '&:hover:not(:disabled)': {
      background: '#e0e7ef',
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  count: {
    minWidth: 20,
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '1.1rem',
    color: '#222',
  },
}));

export default function PassengerCard(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  let [adults, setAdults] = React.useState(1);
  let [childrens, setChildrens] = React.useState(0);
  let [infants, setInfants] = React.useState(0);
  let [cabinBags, setCabinBags] = React.useState(0);
  let [checkedBags, setCheckedBags] = React.useState(0);

  React.useEffect(() => {
    setAdults(props.adults);
    setChildrens(props.childrens);
    setInfants(props.infants);
    // Optionally: setCabinBags/checkedBags from props if needed
  }, [props.adults, props.childrens, props.infants]);

  const handleChange = (adults, childrens, infants, cabinBags, checkedBags) => {
    if (props.onChange) {
      props.onChange({ adults, childrens, infants, cabinBags, checkedBags });
    }
  };

  const update = (key, op) => {
    let newAdults = adults;
    let newChildrens = childrens;
    let newInfants = infants;
    let newCabinBags = cabinBags;
    let newCheckedBags = checkedBags;
    switch (key) {
      case "adults":
        if (op === "+" && adults < 10) newAdults++;
        if (op === "-" && adults > 1) newAdults--;
        setAdults(newAdults);
        break;
      case "childrens":
        if (op === "+" && childrens < 10) newChildrens++;
        if (op === "-" && childrens > 0) newChildrens--;
        setChildrens(newChildrens);
        break;
      case "infants":
        if (op === "+" && infants < 10) newInfants++;
        if (op === "-" && infants > 0) newInfants--;
        setInfants(newInfants);
        break;
      case "cabinBags":
        if (op === "+" && cabinBags < 10) newCabinBags++;
        if (op === "-" && cabinBags > 0) newCabinBags--;
        setCabinBags(newCabinBags);
        break;
      case "checkedBags":
        if (op === "+" && checkedBags < 10) newCheckedBags++;
        if (op === "-" && checkedBags > 0) newCheckedBags--;
        setCheckedBags(newCheckedBags);
        break;
      default:
        break;
    }
    handleChange(
      key === "adults" ? newAdults : adults,
      key === "childrens" ? newChildrens : childrens,
      key === "infants" ? newInfants : infants,
      key === "cabinBags" ? newCabinBags : cabinBags,
      key === "checkedBags" ? newCheckedBags : checkedBags
    );
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Total summary for button
  const totalPassengers = adults + childrens + infants;
  const totalBags = cabinBags + checkedBags;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        className="action-button"
        onClick={handleClick}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
        tabIndex={0}
        aria-label="Select passengers and bags"
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleClick(e); }}
      >
        <IconPerson style={{ fontSize: 22 }} />
        <Typography component="span" style={{ fontWeight: 500 }}>
          {totalPassengers} Passenger{totalPassengers !== 1 ? 's' : ''}
        </Typography>
        {totalBags > 0 && (
          <Typography component="span" style={{ marginLeft: 6, color: '#8b98a9', fontWeight: 400, fontSize: '0.95rem' }}>
            , {totalBags} Bag{totalBags !== 1 ? 's' : ''}
          </Typography>
        )}
        <Typography component="span" style={{ marginLeft: 10 }}>
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Typography>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          style: { boxShadow: '0 8px 32px rgba(0,0,0,0.18)', borderRadius: 16 },
        }}
      >
        <div className={classes.popoverCard}>
          {/* Passengers Section */}
          <Typography className={classes.sectionHeader}>Passengers</Typography>
          <div className={classes.row}>
            <div className={classes.labelGroup}>
              <IconPerson style={{ fontSize: 22 }} />
              <span className={classes.label}>Adults</span>
              <span className={classes.ageRange}>Over 11</span>
            </div>
            <div className={classes.controls}>
              <button
                className={classes.controlBtn}
                aria-label="Decrease adults"
                onClick={() => update("adults", "-")}
                disabled={adults <= 1}
                tabIndex={0}
              >
                <IconMinus fontSize="small" />
              </button>
              <span className={classes.count}>{adults}</span>
              <button
                className={classes.controlBtn}
                aria-label="Increase adults"
                onClick={() => update("adults", "+")}
                disabled={adults >= 10}
                tabIndex={0}
              >
                <IconPlus fontSize="small" />
              </button>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.labelGroup}>
              <IconChild style={{ fontSize: 22 }} />
              <span className={classes.label}>Children</span>
              <span className={classes.ageRange}>2 – 11</span>
            </div>
            <div className={classes.controls}>
              <button
                className={classes.controlBtn}
                aria-label="Decrease children"
                onClick={() => update("childrens", "-")}
                disabled={childrens <= 0}
                tabIndex={0}
              >
                <IconMinus fontSize="small" />
              </button>
              <span className={classes.count}>{childrens}</span>
              <button
                className={classes.controlBtn}
                aria-label="Increase children"
                onClick={() => update("childrens", "+")}
                disabled={childrens >= 10}
                tabIndex={0}
              >
                <IconPlus fontSize="small" />
              </button>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.labelGroup}>
              <IconBaby style={{ fontSize: 22 }} />
              <span className={classes.label}>Infants</span>
              <span className={classes.ageRange}>Under 2</span>
            </div>
            <div className={classes.controls}>
              <button
                className={classes.controlBtn}
                aria-label="Decrease infants"
                onClick={() => update("infants", "-")}
                disabled={infants <= 0}
                tabIndex={0}
              >
                <IconMinus fontSize="small" />
              </button>
              <span className={classes.count}>{infants}</span>
              <button
                className={classes.controlBtn}
                aria-label="Increase infants"
                onClick={() => update("infants", "+")}
                disabled={infants >= 10}
                tabIndex={0}
              >
                <IconPlus fontSize="small" />
              </button>
            </div>
          </div>
          {/* Bags Section */}
          <Typography className={classes.sectionHeader} style={{ marginTop: 18 }}>Bags</Typography>
          <div className={classes.row}>
            <div className={classes.labelGroup}>
              <IconLuggage style={{ fontSize: 22 }} />
              <span className={classes.label}>Cabin baggage</span>
            </div>
            <div className={classes.controls}>
              <button
                className={classes.controlBtn}
                aria-label="Decrease cabin bags"
                onClick={() => update("cabinBags", "-")}
                disabled={cabinBags <= 0}
                tabIndex={0}
              >
                <IconMinus fontSize="small" />
              </button>
              <span className={classes.count}>{cabinBags}</span>
              <button
                className={classes.controlBtn}
                aria-label="Increase cabin bags"
                onClick={() => update("cabinBags", "+")}
                disabled={cabinBags >= 10}
                tabIndex={0}
              >
                <IconPlus fontSize="small" />
              </button>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.labelGroup}>
              <IconSuitcase style={{ fontSize: 22 }} />
              <span className={classes.label}>Checked baggage</span>
            </div>
            <div className={classes.controls}>
              <button
                className={classes.controlBtn}
                aria-label="Decrease checked bags"
                onClick={() => update("checkedBags", "-")}
                disabled={checkedBags <= 0}
                tabIndex={0}
              >
                <IconMinus fontSize="small" />
              </button>
              <span className={classes.count}>{checkedBags}</span>
              <button
                className={classes.controlBtn}
                aria-label="Increase checked bags"
                onClick={() => update("checkedBags", "+")}
                disabled={checkedBags >= 10}
                tabIndex={0}
              >
                <IconPlus fontSize="small" />
              </button>
            </div>
          </div>
        </div>
      </Popover>
    </div>
  );
}

PassengerCard.defaultProps = {
  adults: 1,
  childrens: 0,
  infants: 0,
};
